import { render, staticRenderFns } from "./PlayerAdd.vue?vue&type=template&id=898d5c3c&"
import script from "./PlayerAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports